<template lang="pug">
.cart-item.accessories-item
  .summary__line
    .summary__prod.summary__prod--left
      p {{ item.attributes.product.title }}
      p.summary__time.hidden
      p.summary_time-hide
      a.summary__edit(v-if="item.editable !== false" href='#' @click.prevent="itemEdit($event)") Edit
      a.summary_delete-hide.summary__edit(href='#' @click.prevent="itemDelete($event)") DELETE
    .summary__prod
      p -
    .summary__prod
      p.summary__price-sp.nowrap {{ item.attributes.product.price | currency }}
      p.summary__subtotal-price-hide.nowrap {{ (item.total * 1) + (item.attributes.product.tax_amount * item.payload.count) | currency }}
      .summary__calc
        button.minus-count.summary__minus(:class="{ disabled: item.payload.count <= 1 }" @click="setCount(item.payload.count - 1)")
        p.nowrap {{ item.payload.count }}
        button.plus-count.summary__plus(:class="{ disabled: item.payload.count >= maxAccommodation }" @click="setCount(item.payload.count + 1)")
    .summary__prod.summary__price
      p.nowrap {{ item.attributes.product.price | currency }}
    .summary__prod
      p.nowrap {{ item.attributes.product.price * item.payload.count | currency }}
    .summary__prod
      p.nowrap {{ item.attributes.product.tax * item.payload.count | currency }}
    .summary__prod.summary__prod--right.summary__prod--last
      p.nowrap {{ (Number(item.attributes.product.price) + Number(item.attributes.product.tax)) * item.payload.count | currency }}
      button.summary__remove-product(@click.prevent="itemDelete($event)")
</template>

<script>
const EventBus = window.VueEventBus
import CartMixins from '../../../components/_mixins/location-checkout'
import RaceMixins from '../../../components/_mixins/races'
import config from '../../../lib/config'
const {
  supercharged,
} = config
const { races: {ninja: raceSettings = {}} = {} } = supercharged

export default {
  name: 'accessories-cart-item',
  settings: 'page.cart',
  translations: 'page.cart',
  mixins: [
    CartMixins,
    RaceMixins
  ],

  props: {
    item: {},
    items: {},
    groupedItems: {},
    cartView: {},
    showItemRates: {
      default: false
    },
  },
  computed: {
     maxAccommodation() {
      return raceSettings.max_accommodation || raceSettings.max_racers || 150
    },
  },
  methods: {
    itemDelete($event) {
      const item = this.item
      this.cartView.cartItemButtonClicked({
        $event,
        actionName: 'delete',
        id: this.item.id,
        item,
        cartItems: this.currentCartItems,
        button: {}
      })
      // this.removeCartItem(item)
      EventBus.$emit('cart-item-deleted', item, this, this.$parent)
      EventBus.$emit('cart-item-deleted-' + item.type, item, this, this.$parent)
    },

    setCount(count) {
      const originalItem = this.item
      const attributes = originalItem.attributes
      const id = originalItem.id
      const parentId = attributes.parentId
      const item = JSON.parse(JSON.stringify(attributes.localItem))
      item.count = count
      const updates = this.updateAccessoriesCartItem({id, item, parentId})
      this.updateCartItem(updates)
      EventBus.$emit('cart.validate')
    },
  }
}
</script>
